import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SMPickerRange } from '../../components/smr-date-picker/smr-date-picker.component';
import { ReportService } from 'src/app/services/report.service';
import { StripeService } from 'src/app/services/stripe.service';
import { SaleService } from 'src/app/services/sale.service';
import { ModalController } from '@ionic/angular';
import { Utilities } from '../../utilities/utilities';
import { RegisterClosureSalesModalPage } from '../../register-closures/register-closure-sales-modal/register-closure-sales-modal.page';
interface primeNgCol {
  field: string;
  header: string;
}

@Component({
  selector: 'app-payment-processing',
  templateUrl: './payment-processing.page.html',
  styleUrls: ['./payment-processing.page.scss'],
})
export class PaymentProcessingPage implements OnInit {
  public startDate: Date;

  public endDate: Date;

  public totalCharged: number = 0;
  public totalFees: number = 0;
  public totalDeposited: number = 0;

  public stats = [];
  public cols: primeNgCol[];

  public isLoading = true;

  public segment: string = 'payments';

  public stripeUserId: string;

  constructor(
    public reportService: ReportService,
    public stripeService: StripeService,
    public saleService: SaleService,
    private changeDetectorRef: ChangeDetectorRef,
    public modalCtrl: ModalController
  ) {
    this.stats = [];
    this.cols = [
      { field: 'date', header: 'Date' },
      { field: 'totalCharged', header: 'Total Charged' },
      { field: 'fees', header: 'Fees' },
      { field: 'totalDeposited', header: 'Total Deposited' },
    ];
  }

  ngOnInit() {
    if (!this.startDate) {
      let dateFromCache: string = localStorage.getItem('datePickerStartDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.startDate = Utilities.parseDate(dateFromCache);
      }
    }

    if (!this.endDate) {
      let dateFromCache: string = localStorage.getItem('datePickerEndDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.endDate = Utilities.parseDate(dateFromCache);
      }
    }
    this.loadStripeData();
  }

  public loadStripeData() {
    this.isLoading = true;
    this.stripeService.loadStripeAccountInfo().subscribe({
      next: async ({ stripeAccountInfo }) => {
        this.isLoading = false;
        this.stripeUserId =
          stripeAccountInfo.toArray().length !== 0
            ? stripeAccountInfo.toArray()[0]['stripeUserID']
            : null;

        if(this.segment === "payments") {
          this.viewPayments();
        }
        this.changeDetectorRef.detectChanges();
      },
      error: (err) => {
        this.isLoading = false;
        this.changeDetectorRef.detectChanges();
      },
    });
  }

  public rangeChanged(dateRange: SMPickerRange) {
    this.startDate = dateRange.start;
    this.endDate = dateRange.end;
    this.loadStats();
  }

  public async loadStats() {
    this.stats = await this.reportService
      .loadPaymentProcessingStats(this.startDate, this.endDate)
      .toPromise();
    this.isLoading = false;
    this.totalCharged = this.stats
      .map((row) => row['totalCharged'])
      .reduce((total, row) => (total += row), 0);
    this.totalFees = this.stats
      .map((row) => row['fees'])
      .reduce((total, row) => (total += row), 0);
    this.totalDeposited = this.stats
      .map((row) => row['totalDeposited'])
      .reduce((total, row) => (total += row), 0);
  }

  public async loadCharges() {
    await this.stripeService.fetchAllCharges().toPromise();
  }

  public viewReceipt(saleID) {
    this.saleService.loadSaleByID(saleID).subscribe({
      next: async (sale) => {
        const modal = await this.modalCtrl.create({
          component: RegisterClosureSalesModalPage,
          componentProps: { sale: sale },
        });
        return await modal.present();
      },
      error: (e) => {
        this.isLoading = false;
        this.changeDetectorRef.markForCheck();
      },
    });
  }

  public viewPayouts() {
    this.isLoading = true;
    this.stripeService
      .fetchClientSecret({ accountID: this.stripeUserId })
      .subscribe((data) => {
        const stripeConnectInstance =
          this.stripeService.createStripeConnectInstance(data['client_secret']);
        const payoutComponent = stripeConnectInstance.create('payouts');
        const container = document.getElementById('container');
        if (container.hasChildNodes()) {
          container.replaceChild(payoutComponent, container.firstChild);
        } else {
          container.appendChild(payoutComponent);
        }
          this.isLoading = false;
      });
  }

  public viewPayments() {
    this.isLoading = true;
    this.stripeService
      .fetchClientSecret({ accountID: this.stripeUserId })
      .subscribe((data) => {
        const stripeConnectInstance =
          this.stripeService.createStripeConnectInstance(data['client_secret']);
        const paymentComponent = stripeConnectInstance.create('payments');
        const container = document.getElementById('container');
        if (container.hasChildNodes()) {
          container.replaceChild(paymentComponent, container.firstChild);
        } else {
          container.appendChild(paymentComponent);
        }
          this.isLoading = false;
      });
  }

  public changeSegment($event){
    this.segment = $event.detail.value;
    if (this.segment === 'payments') {
      this.viewPayments();
    }
    if (this.segment === 'payouts') {
      this.viewPayouts();
    }
    if (this.segment === 'fees') {
      this.loadStats();
    }
  }
}
